import * as React from 'react';

import CourseraMetatags from 'bundles/seo/components/CourseraMetatags';
import type { ConsumerPathwayRolePageDataContextType } from 'bundles/unified-career-academy/contexts/ConsumerPathwayRolePageDataContext';

import _t from 'i18n!nls/career-academy';

type Props = {
  pageData: ConsumerPathwayRolePageDataContextType;
};

export const ConsumerPathwayRolePageSEO = ({ pageData }: Props) => {
  if (!pageData?.careerRoleData?.name) {
    return null;
  }

  const title = _t('#{name} Learning Paths: Courses and Resources by Skill Level', {
    name: pageData.careerRoleData.name,
  });

  return (
    <CourseraMetatags
      metaNameAndProperties={{
        title,
        description: pageData?.careerRoleData?.description
          ? _t(
              "Navigate your growth as a #{name}. Find courses and resources by skill level to support your career growth, whether you're just starting or looking to advance.",
              { name: pageData.careerRoleData.name }
            )
          : undefined,
        ogAndTwitterTitle: title,
        absoluteImageHref: pageData?.careerRoleData?.heroImage?.url ?? undefined,
        twitterCardWithLargeImage: true,
        disableCourseraDescriptionSuffix: true,
        enableCrawlerIndexing: true,
      }}
    />
  );
};

export default ConsumerPathwayRolePageSEO;
